"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getInitialsFromString = function (str) {
    return str.split(/\s+/).map(function (s) { return s[0]; });
};
exports.default = getInitialsFromString;
